import "./index.scss";
import { Badge } from "@wise-emotions/react-badge";
import {
  GeneralMediumCheck2,
  GeneralMediumClose,
} from "@wise-emotions/react-icons";
import { Label } from "@wise-emotions/react-label";
import React from "react";
import cn from "classnames";
// @ts-expect-error
import football from "./assets/football.svg";

const COLOR_MAP = {
  grey: "linear-gradient(90deg, #A8A8A8 30%, #DADADA 100%)",
  yellow: "linear-gradient(90deg, #FEE01A 30%, #FFF4AA 100%)",
  blue: "linear-gradient(90deg, #3652BD 30%, #6096D2 100%)",
  red: "linear-gradient(90deg, #C8102E 30%, #DB6478 100%)",
  green: "linear-gradient(270deg, #5FE092 3.13%, #00CD51 50%)",
  pink: "linear-gradient(90deg, #DF287F 29.74%, #EB79AF 100%)",
  aqua: "linear-gradient(90deg, #96DFCE 29.82%, #BDEBE0 100%)",
  "recycled-green": "linear-gradient(90deg, #A2A568 29.91%, #C5C6A0 100%)",
  black: "linear-gradient(90deg, #000000 29.99%, #666666 100%)",
  figc: "linear-gradient(90deg, #2052D8 29.77%, #547BE4 100%)",
  orange: "linear-gradient(90deg, #DE5307 30%, #EA9160 100%)",
  football: `url(${football})`,
};

type Color = keyof typeof COLOR_MAP;

export type Props =
  | {
      variant: "description";
      label: string;
      description: string;
      tooltip?: string;
    }
  | {
      variant: "checkIcon";
      label: string;
      isChecked: boolean;
      tooltip?: string;
    }
  | {
      variant: "numericValue";
      label: string;
      value: number;
    }
  | {
      variant: "colorList";
      label: string;
      colorList: Color[];
      tooltip?: string;
    }
  | {
      variant: "promo";
      description: string;
    };

const OfferDetailItem = ({ variant, ...props }: Props) => (
  <div className="offer-detail-item">
    {"label" in props && (
      <Label
        title={props.label}
        isBold
        htmlFor=""
        description={
          variant !== "promo" && "description" in props ? props.description : ""
        }
        {...("tooltip" in props
          ? { variant: "tooltip", tooltipText: props.tooltip }
          : { variant: "default" })}
      />
    )}

    {variant !== "description" && (
      <div className="offer-detail-item__content">
        {"isChecked" in props && (
          <div
            className={cn("offer-detail-item__content__icon", {
              "offer-detail-item__content__icon--check": props.isChecked,
              "offer-detail-item__content__icon--close": !props.isChecked,
            })}
          >
            {props.isChecked ? <GeneralMediumCheck2 /> : <GeneralMediumClose />}
          </div>
        )}

        {"value" in props && (
          <div className="offer-detail-item__content__numeric-value">
            {props.value}
          </div>
        )}

        {"colorList" in props && (
          <div className="offer-detail-item__content__color-list">
            {props.colorList.map((color) => (
              <div
                key={color}
                className="offer-detail-item__content__color-list__color"
                style={{
                  background: COLOR_MAP[color],
                  backgroundPosition: "center",
                }}
              />
            ))}
          </div>
        )}

        {variant === "promo" && "description" in props && (
          <div className="offer-detail-item__content__promo">
            <div className="offer-detail-item__content__promo__badge">
              <Badge
                variant="iconAndLabel"
                theme="promo"
                label="Promo"
                contrast="high-contrast"
              />
            </div>
            <p className="offer-detail-item__content__promo__label">
              {props.description}
            </p>
          </div>
        )}
      </div>
    )}
  </div>
);

OfferDetailItem.displayName = "OfferDetailItem";

export default OfferDetailItem;
